import Glide, {Controls, Breakpoints, Swipe} from '@glidejs/glide/dist/glide.modular.esm'
import '@fancyapps/fancybox';
import {Utils} from "./Utils";

export class webinarSlider {
    constructor() {
        const sliders = document.querySelectorAll('.glide-slider')
        const sliderMinimalClass = ".glide-slider-minimal"
        const sliderUploadsClass = '.glide-uploads'
        let slidersLightGlides = new Array()
        let uploadsGlides = new Array()
        let _this = this
        window.webinarSliderDebugOn  = false

        if (sliders.length > 0) {
            sliders.forEach(item => {
                let slidesCount = item.getAttribute('data-slides-count')
                _this.initializeSlider(item,slidesCount,false)
            })
        }
        $('.lightbox').fancybox({
            'hideOnContentClick': true,

            onInit: () => {
                _this.collapseAccordion()
            },
            afterShow: function (instance, slide) {
                let sliderMinimal = _this.getSliderToShow(this.src,sliderMinimalClass)
                if (typeof sliderMinimal !== "undefined") {
                    let slidesCount = sliderMinimal.getAttribute('data-slides-count')
                    slidersLightGlides.push(_this.initializeSlider(sliderMinimal,slidesCount,true))
                }
                let sliderUploads = _this.getSliderToShow(this.src, sliderUploadsClass)
                if (typeof sliderUploads !== 'undefined') {
                    let uploadsCount = sliderUploads.getAttribute('data-files-count')
                    uploadsGlides.push(_this.initializeSlider(sliderUploads,uploadsCount,true))
                }
            },
            afterClose:function (instance,slide) {
                _this.debug('closing')
                if (slidersLightGlides.length > 0) {
                    slidersLightGlides.forEach(item => {
                        _this.destroySlider(item)
                    })
                    slidersLightGlides.length = 0
                }
                if (uploadsGlides.length > 0) {
                    uploadsGlides.forEach(item => {
                        _this.debug('Destroy upload item',item)
                        _this.destroySlider(item)
                    })
                    uploadsGlides.length = 0
                }
            }
        })
        $('#accordion-tradeshow').on('hidden.bs.collapse', function (e) {
            _this.debug("Accordion hide",e)
            if (slidersLightGlides.length > 0) {
                slidersLightGlides.forEach(item => {
                    _this.destroySlider(item)
                })
                slidersLightGlides.length = 0
            }
            if (uploadsGlides.length > 0) {
                uploadsGlides.forEach(item => {
                    _this.destroySlider(item)
                })
                uploadsGlides.length = 0

            }
        })
        $('#accordion-tradeshow').on('shown.bs.collapse', function (e) {
            _this.debug("Accordion show",e)
            setTimeout(function () {
                let sliderMinimal = _this.getSliderToShow(e.target, sliderMinimalClass)
                if (typeof sliderMinimal !== 'undefined') {
                    let slidesCount = sliderMinimal.getAttribute('data-slides-count')
                    slidersLightGlides.push(_this.initializeSlider(sliderMinimal,slidesCount,true))
                }
                let sliderUploads = _this.getSliderToShow(e.target, sliderUploadsClass)
                if (typeof sliderUploads !== 'undefined') {
                    let uploadsCount = sliderUploads.getAttribute('data-files-count')
                    uploadsGlides.push(_this.initializeSlider(sliderUploads,uploadsCount,true))
                }
            }, 300)
        })
    }

    getSliderToShow = (context,selector) => {
        this.debug('get Slider Context', context)
        this.debug('get Slider Element', selector)
        let slidersLight = $(selector, context)[0]
        this.debug('Slider element', slidersLight)
        return slidersLight
    }

    destroySlider = (el) => {
        this.debug('Destroy slider')
        this.changeSliderVisibility(el,true)
        el.destroy()
    }

    initializeSlider = (item, slidesCount,isLight) => {
        this.debug('Initialize Item',item)
        this.debug('Initialize Count',slidesCount)
        let glide = new Glide(item, this.getConfig(slidesCount))
        glide.mount({Controls, Breakpoints, Swipe})
        this.changeSliderVisibility(glide,isLight)


        return this.setSliderState(slidesCount,glide)
    }

    setSliderState = (count, el, width = $(window).width()) => {
        this.debug("Slider state count", count)
        if (width > 1199 && count < 4) el.disable()
        if (width > 767 && width < 1200 && count < 3) el.disable()
        if (width < 768 && count == 1) el.disable()
        if (el.disabled) this.removeControls(el)
        return el
    }

    removeControls = (el) => $(el.selector).find("[data-glide-el='controls']").remove()

    changeSliderVisibility = (el,isLight) => {
        this.debug("Visibility element", el)
        if(isLight) $("#"+el.selector.id).toggleClass('invisible sliderShowAnimation')
        this.debug("Visibility ", $('#'+el.selector.id)[0])
    }

    getBreakpointsConfig = (count) => {
        if (count == 2) return {"small": 1, "medium": 2, "large": 2}
        if (count == 1) return {"small": 1, "medium": 1, "large": 1}
        return {"small": 1, "medium": 2, "large": 3}
    }

    getConfig = (count) => {
        let breakpointConf = this.getBreakpointsConfig(count)
        return {
            type: 'carousel',
            gap: 30,
            perView: breakpointConf['large'],
            breakpoints: {
                768: {
                    perView: breakpointConf['small']
                },
                1200: {
                    perView: breakpointConf['medium']
                },
            }
        }
    }
    debug = (msg,obj) => (window.webinarSliderDebugOn == true ? console.log(msg,obj) : '')

    collapseAccordion = () =>$("[data-parent='#accordion-tradeshow']").collapse('hide')
}

Utils.executeWhenDocumentIsReady(() => {
    const lightboxTrigger = document.querySelectorAll('.lightbox');

    lightboxTrigger.forEach((trigger) => {
        trigger.addEventListener('click', function () {
            setTimeout(function () {
                window.dispatchEvent(new Event('resize'));
            }, 100);
        });
    })
});
